import { UtilService } from 'app/services/util.service';
import { LabelEnum } from 'app/shared/enums';

const required = <T>(
  value: string | number | boolean | undefined | null | Array<T>
) => (UtilService.hasValue(value) ? undefined : LabelEnum.FieldRequired);

export default required;
